import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { LockIcon } from "../../../../icons/LockIcon";
import { UnlockIcon } from "../../../../icons/UnlockIcon";
import { IconButton } from "../../../../icon-button/IconButton";
const StyledIconButton = styled(IconButton) `
  svg {
    margin-bottom: 10px;
  }
`;
export const LockButton = ({ isLocked, setIsLocked, lockLabel, unlockLabel }) => (_jsx(StyledIconButton, { icon: isLocked ? _jsx(LockIcon, { "aria-hidden": "true", size: "16" }) : _jsx(UnlockIcon, { "aria-hidden": "true", size: "16" }), tooltipContents: isLocked ? unlockLabel : lockLabel, onClick: () => setIsLocked(!isLocked) }));
